import { render, staticRenderFns } from "./B.vue?vue&type=template&id=2fce3491&"
import script from "./B.vue?vue&type=script&lang=js&"
export * from "./B.vue?vue&type=script&lang=js&"
import style0 from "./B.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports